<template>
<div>
    <div v-if="modCapImg == 1 || modCapImg == 2" class="col-12 d-flex justify-content-start">
        <button class="btn btn-icon btn-simple btn-twitter" @click="modCapImg = 0">
            <i class="tim-icons icon-minimal-left"></i>
        </button>
    </div>

    <div class="row" style="margin-top: 10px;">
        <div v-show="modCapImg == 0">
            <base-button slot="footer" type="success" @click="modCapImg = 1" round block size="lg">
                <i class="tim-icons icon-camera-18" /> Enviar Imagem
            </base-button>

            <base-button slot="footer" type="success" @click="modCapImg = 2" round block size="lg">
                <i class="tim-icons icon-camera-18" /> Capturar Foto
            </base-button>
            <div class="alert-box">
                <strong><i class="fas fa-exclamation-triangle icon_alert"></i>Atenção: Critérios para a Foto Facial</strong>
                <ul>
                    <li>
                        <strong>Posição da Face:</strong> A face deve estar centralizada na foto, tanto na horizontal quanto na vertical. A foto não pode estar nem muito próxima, nem muito distante, com a face completamente contida na imagem e uma pequena margem em todos os lados.
                    </li>
                    <li>
                        <strong>Centralização da Pose:</strong> A pessoa deve estar posicionada de frente para a câmera, com o rosto voltado diretamente para a lente.
                    </li>
                    <li>
                        <strong>Nitidez e Iluminação:</strong> A região da face deve ser nítida e bem iluminada, sem sombras ou desfoques que comprometam a clareza da imagem.
                    </li>
                </ul>
            </div>
        </div>

        <div v-show="modCapImg == 1">
            <div class="row m-0 p-0">
                <div class="col-md-12 p-2">
                    <h4 class="card-title">Arquivo</h4>
                    <image-upload @change="onImageChange" select-text="Selecione o arquivo" :formatos-validos="['image/jpeg', 'image/png']" :msg-error="'Somente imagens nos formatos JPG ou PNG são aceitas'" />
                </div>
            </div>
            <div class="alert-box">
                <strong> <i class="fas fa-exclamation-triangle icon_alert"></i>Atenção: Critérios para a Foto Facial</strong>
                <ul>
                    <li><strong>Formatos de Arquivo Aceitos:</strong> JPG ou PNG.</li>
                    <li><strong>Dimensões da Imagem:</strong>
                        <ul>
                            <li><strong>Tamanho Mínimo:</strong> 160 x 160 pixels.</li>
                            <li>
                                <strong>Tamanho Máximo:</strong> O produto das dimensões da imagem não deve exceder 2.073.600 pixels (equivalente a 1920 x 1080 pixels).
                                Exemplos de tamanhos aceitos incluem 300 x 300, 600 x 600, e 2000 x 1000 pixels. Imagens maiores, como 4000 x 3000 pixels, <b>não</b> serão aceitas.
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>

        <div v-show="modCapImg == 2" class="col-md-12 text-left">
            <h4 slot="header" class="card-title">Selecione a Câmera</h4>
            <div class="d-flex flex-row justify-content-between">
                <el-select class="select-success mb-3 pagination-select w-100" name="cam" id="cam" v-model="selected" placeholder="Selecione a Câmera" @change="changeCamera(selected)">
                    <el-option class="select-success" v-for="camera in cameras" :key="camera.deviceId" :label="camera.label" :value="camera.deviceId">
                    </el-option>
                </el-select>
            </div>
        </div>
    </div>

    <div v-show="modCapImg == 2" class="row" style="margin-top: 10px;">
        <div class="col-md-12 text-left">
            <video ref="video" :width="width" :height="height" :src="source" :autoplay="autoplay" :playsinline="playsinline" />
        </div>
    </div>

    <div v-show="modCapImg == 2" class="row" style="margin-top: 10px;">
        <div class="col-md-12 text-left">
            <base-button v-if="!imgCapturada" native-type="submit" slot="footer" type="success" @click="capImg()" round block size="lg">
                <i class="tim-icons icon-camera-18" /> Capturar Foto
            </base-button>

            <base-button v-else native-type="submit" slot="footer" type="warning" @click="(imgCapturada = ''), setupMedia(), loadCameras()" round block size="lg">
                <i class="tim-icons icon-camera-18" /> Refazer
            </base-button>
        </div>
    </div>

    <Carregando v-if="isLoading" />
</div>
</template>

<script>
// import Paciente from "../../classSamel/Paciente"
// import { bus } from "../../main"
import Carregando from "../../../../src/pages/Loads/Carregando.vue";
import swal from "sweetalert2";
import moment from "moment";
import {
    ImageUpload
} from "@/components/index";

export default {
    name: "modal-rec-facial-v2",
    components: {
        Carregando,
        ImageUpload,
    },
    props: {
        typePonto: {
            type: Number,
            default: 0,
        },
        pacientee: {
            type: Object,
            default: null,
        },
        playsinline: {
            type: Boolean,
            default: true,
        },
        autoplay: {
            type: Boolean,
            default: true,
        },
        width: {
            type: [Number, String],
            default: "100%",
        },
        height: {
            type: [Number, String],
            default: "100%",
        },
        resolution: {
            type: Object,
            default: null,
            validator: (value) => {
                return value.height && value.width;
            },
        },
        cpf: {
            type: [String, Number],
            default: "",
        },
        cnpj: {
            type: String,
            default: "",
        },
        name: {
            type: String,
            default: "",
        },
        sendFoto: {
            type: [Boolean, String],
            default: "",
        },
        hasLoading: {
            type: Boolean,
            default: false,
        },
        endpoint: {
            type: String,
            default: "/classify",
        },
        isJson: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
            abono: {
                data: "",
                hora: "",
                tipo: "",
                file: null,
            },
            imgCapturada: "",
            modCapImg: 0,
            showimg: true,
            cont: 0,
            load28: false,
            teste: null,
            modals: {
                modal3: false,
            },
            source: null,
            canvas: null,
            camerasListEmitted: false,
            cameras: [],
            photo: null,
            device: null,
            selected: "",
            cam: false,
            load_modal: false,
            showToken: false,
            showButtons: true,
            listProcedimentos: [],
            errorResponse: {
                status: false,
                message: "",
            },
            successResponse: {
                status: false,
                message: "",
            },
        };
    },

    watch: {},
    methods: {
        moment: function (data) {
            return moment(data);
        },

        onImageChange(file) {
            if (!file) return;

            this.imgCapturada = file.replace(/^data:image\/[a-z]+;base64,/, "");

            this.sendStatus();
        },

        showSwal2(type, title, text, typeMsg) {
            if (type === "auto-close") {
                swal({
                    title: title,
                    text: text,
                    type: typeMsg,
                    timer: 3000,
                    showConfirmButton: false,
                });
            }
        },

        showSwal(type) {
            if (type === "success-message-recognition") {
                swal({
                    title: `Muito Bom!`,
                    text: "Reconhecimento facial realizado com sucesso!",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-success btn-fill",
                    type: "success",
                }).then(() => {
                    // location.reload()
                });
            } else if (type === "success-message-register") {
                swal({
                    title: `Muito Bom!`,
                    text: "Usuario cadastrato com sucesso!",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-success btn-fill",
                    type: "success",
                }).then(() => {
                    // location.reload()
                });
            } else if (type === "error-message") {
                swal({
                    title: `Puts :(`,
                    text: "Não conseguimos identifica-lo!",
                    buttonsStyling: false,
                    confirmButtonClass: "btn btn-success btn-fill",
                    type: "error",
                }).then(() => {
                    this.setupMedia();
                    this.loadCameras();
                    // location.reload()
                });
            }
        },
        /* able(){
                bus.$emit('ableButtonEmail', true)
                bus.$emit('ativarMM', true)
            }, */
        closeModal( /* e */ ) {
            this.modals.modal3 = false;
            this.selected = "";
            this.errorResponse.status = false;
            this.errorResponse.message = "";
            this.successResponse.status = false;
            this.successResponse.message = "";
            this.stop();
            //            bus.$emit('relaodGuia', true)

            //            bus.$emit('success', "Paciente autorizado para procedimento(s).");
            //            bus.$emit('limpalist');
        },
        loadCameras() {
            this.cameras = [];
            navigator.mediaDevices
                .enumerateDevices()
                .then((deviceInfos) => {
                    for (let i = 0; i !== deviceInfos.length; ++i) {
                        let deviceInfo = deviceInfos[i];
                        if (deviceInfo.kind === "videoinput") {
                            this.cameras.push(deviceInfo);
                        }
                    }
                    if (this.cameras.length > 0) {
                        this.selected = this.cameras[0].deviceId;
                        this.changeCamera(this.selected);
                    }
                })
                .then(() => {
                    if (!this.camerasListEmitted) {
                        if (this.selectFirstDevice && this.cameras.length > 0) {
                            this.deviceId = this.cameras[0].deviceId;
                        }
                        this.$emit("cameras", this.cameras);
                        this.camerasListEmitted = true;
                    }
                })
                .catch((error) => this.$emit("notsupported", error));
        },

        capImg() {
            this.pause();
            this.imgCapturada = this.capture();
            this.imgCapturada = this.imgCapturada.replace(/^data:image\/[a-z]+;base64,/, "");
            this.sendStatus();
        },

        CapturarImagem(cpf) {
            let current = this;

            let body;
            if (this.isJson) {
                body = {
                    image: this.imgCapturada,
                    nrCpf: String(cpf).replace(/\D/g, ""),
                };
                if (this.endpoint === "/updateFoto") {
                    body.cnpj = this.cnpj;
                    body.name = this.name;
                }
            } else {
                body = new FormData();
                body.append("image", this.imgCapturada);
                body.append("nrCpf", cpf);
                if (this.endpoint === "/updateFoto") {
                    body.append("cnpj", this.cnpj);
                    body.append("name", this.name);
                }
            }

            if (cpf != "" && this.imgCapturada != "") {
                if (this.hasLoading) this.isLoading = true;
                this.axios
                    .post(`${process.env.VUE_APP_API_ADDRESS_REC_FACIAL}${this.endpoint}`, body)
                    .then(function (response) {
                        if (current.hasLoading) current.isLoading = false;
                        current.$emit("success", response.data);

                        if (
                            response.data.default_face_matching_classification &&
                            response.data.message == "User successfully registered"
                        ) {
                            current.imgCapturada == "";
                            // current.showSwal('success-message-register')
                            // current.registrarPonto(img)
                        } else if (
                            response.data.default_face_matching_classification &&
                            response.data.message == "The classification succeeded"
                        ) {
                            current.imgCapturada == "";
                            // current.showSwal('success-message-recognition')
                            // current.registrarPonto(img)
                        } else {
                            // current.showSwal('error-message')
                        }
                    })
                    .finally(() => {})
                    .catch(function ( /* e */ ) {
                        if (current.hasLoading) current.isLoading = false;
                        // current.showSwal('error-message')
                        // current.registrarPonto(img)
                        // current.atualizarPagina();
                    });
            }
        },

        legacyGetUserMediaSupport() {
            return (constraints) => {
                let getUserMedia =
                    navigator.getUserMedia ||
                    navigator.webkitGetUserMedia ||
                    navigator.mozGetUserMedia ||
                    navigator.msGetUserMedia ||
                    navigator.oGetUserMedia;
                // Some browsers just don't implement it - return a rejected promise with an error
                // to keep a consistent interface
                if (!getUserMedia) {
                    return Promise.reject(
                        new Error("getUserMedia is not implemented in this browser")
                    );
                }
                // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
                return new Promise(function (resolve, reject) {
                    getUserMedia.call(navigator, constraints, resolve, reject);
                });
            };
        },
        /**
         * setup media
         */
        setupMedia() {
            if (navigator.mediaDevices === undefined) {
                navigator.mediaDevices = {};
            }
            if (navigator.mediaDevices.getUserMedia === undefined) {
                navigator.mediaDevices.getUserMedia = this.legacyGetUserMediaSupport();
            }
            this.testMediaAccess();
        },

        /**
         * change to a different camera stream, like front and back camera on phones
         */
        changeCamera(deviceId) {
            this.stop();
            this.$emit("camera-change", deviceId);
            this.loadCamera(deviceId);
        },
        /**
         * load the stream to the
         */
        loadSrcStream(stream) {
            if ("srcObject" in this.$refs.video) {
                // new browsers api
                this.$refs.video.srcObject = stream;
            } else {
                // old broswers
                this.source = window.HTMLMediaElement.srcObject(stream);
            }
            // Emit video start/live event
            this.$refs.video.onloadedmetadata = () => {
                this.$emit("video-live", stream);
            };
            this.$emit("started", stream);
        },
        /**
         * stop the selected streamed video to change camera
         */
        stopStreamedVideo(videoElem) {
            let stream = videoElem.srcObject;
            let tracks = stream.getTracks();
            tracks.forEach((track) => {
                // stops the video track
                track.stop();
                this.$emit("stopped", stream);
                this.$refs.video.srcObject = null;
                this.source = null;
            });
        },
        // stop the video
        stop() {
            if (this.$refs.video !== null && this.$refs.video.srcObject) {
                this.stopStreamedVideo(this.$refs.video);
            }
        },
        // start the video
        start() {
            if (this.deviceId) {
                this.loadCamera(this.deviceId);
            }
        },
        // pause the video
        pause() {
            if (this.$refs.video !== null && this.$refs.video.srcObject) {
                this.$refs.video.pause();
            }
        },
        // resume the video
        resume() {
            if (this.$refs.video !== null && this.$refs.video.srcObject) {
                this.$refs.video.play();
            }
        },
        /**
         * test access
         */
        testMediaAccess() {
            let constraints = {
                video: true
            };
            if (this.resolution) {
                constraints.video = {};
                constraints.video.height = this.resolution.height;
                constraints.video.width = this.resolution.width;
            }
            navigator.mediaDevices
                .getUserMedia(constraints)
                .then((stream) => {
                    //Make sure to stop this MediaStream
                    let tracks = stream.getTracks();
                    tracks.forEach((track) => {
                        track.stop();
                    });
                    this.loadCameras();
                })
                .catch((error) => this.$emit("error", error));
        },
        /**
         * load the camera passed as index!
         */
        loadCamera(device) {
            let constraints = {
                video: {
                    deviceId: {
                        exact: device
                    }
                }
            };
            if (this.resolution) {
                constraints.video.height = this.resolution.height;
                constraints.video.width = this.resolution.width;
            }
            navigator.mediaDevices
                .getUserMedia(constraints)
                .then((stream) => this.loadSrcStream(stream))
                .catch((error) => this.$emit("error", error));
        },
        /**
         * capture screenshot
         */
        capture() {
            this.photo = this.getCanvas().toDataURL(this.screenshotFormat);
            return this.getCanvas().toDataURL(this.screenshotFormat);
        },
        /**
         * get canvas
         */
        getCanvas() {
            let video = this.$refs.video;
            if (!this.ctx) {
                let canvas = document.createElement("canvas");
                canvas.height = video.videoHeight;
                canvas.width = video.videoWidth;
                this.canvas = canvas;
                this.ctx = canvas.getContext("2d");
            }
            const {
                ctx,
                canvas
            } = this;
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            return canvas;
        },

        sendStatus() {
            this.$emit("statusfoto", this.imgCapturada ? true : false);
        },
    },
    created() {},
    mounted() {
        this.setupMedia();
        this.loadCameras();

        this.$root.$on("enviarFoto", (status) => {
            if (status) {
                this.CapturarImagem(this.cpf);
            } else return;
        });
    },

    beforeDestroy() {
        this.$root.$off("enviarFoto");
    }
};
</script>

<style scoped>
#vitrine {
    width: 100%;
}

.space {
  margin-top: 10 px;
}

.icon_alert {
    color: red;
    margin-right: 5px;
}

.alert-box { 
    padding: 15px;
    border: 1px solid #ccc;
    background-color: #f9f9f9;
    border-radius: 5px;
    text-align: left;
    font-size:12px;
    max-width: 500px;
    margin-left:5%;
}


</style>
